<script lang="ts" setup>
import { TuiButton } from '@clickbar/tailwindui-vue'

import type { PageElementOfType } from '../page-builder'
import type { StrictRouteName } from '@/app/route'

const props = defineProps<{
  element: PageElementOfType<'linkButton'>
}>()
const tenant = useTenant()

const href = computed(() => {
  if (props.element.data.target.type === 'internal') {
    return props.element.data.target.route
      ? route(props.element.data.target.route as StrictRouteName, { tenant: tenant.key })
      : null
  } else {
    return props.element.data.target.url
  }
})
</script>

<template>
  <TuiButton
    :color="element.data.color"
    :type="element.data.target.type === 'internal' ? 'inertia-link' : 'a'"
    :href
    :secondary="element.data.secondary"
    block
    target="_blank"
  >
    <template #icon="iconProps">
      <IHeroiconsArrowTopRightOnSquare
        v-if="element.data.target.type === 'external'"
        v-bind="iconProps"
      />
    </template>
    {{ element.data.label }}
  </TuiButton>
</template>
